export type ChartSummaryProps = {
  label: string;
  kind: 'line' | 'stock' | 'seasonal' | 'forward-curve';
  visibleSeries: number;
  totalSeries: number;
  rangeLabel?: string;
};

const ChartSummary = ({
  label,
  kind,
  visibleSeries,
  totalSeries,
  rangeLabel
}: ChartSummaryProps) => {
  const rangeSummary = rangeLabel ? ` Range: ${rangeLabel}.` : '';

  if (totalSeries === 0) {
    return (
      <p>
        {label}. No chart data is available.
        {rangeSummary}
      </p>
    );
  }

  const kindLabel = kind === 'forward-curve' ? 'forward curve' : kind;

  return (
    <p>
      {label}, {kindLabel} chart. {visibleSeries} of {totalSeries} series visible.
      {rangeSummary}
    </p>
  );
};

export default ChartSummary;
